module.exports = __webpack_public_path__ + "static/media/Vivillon_gaussian2.48057f0e.png";